var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"briq-alert",class:("briq-" + _vm.variant + (_vm.column ? ' column' : ''))},[_c('BriqIcon',{attrs:{"name":"icon-info-icon"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }